import { R3VisualComponentBase } from "../../../../classes/base/R3VisualComponenteBase.classes";

type R3DivStyle = {
	backgroundColor?: string;
	width?: string;
	height?: string;
	border?: string;
}

export default class R3DivClass extends R3VisualComponentBase {
	override style: R3DivStyle = {};
}